// extracted by mini-css-extract-plugin
export default {"container":"style_container__fch8F","titleSection":"style_titleSection__+H3UB"};